import { Resource } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isResource } from 'src/containers/ProjectDiagram/utils/data';
import { getResourceKey } from 'src/containers/ProjectDiagram/utils/resource/createResource';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateResourceName =
  (projectResourceId: string, newResourceName: string) => (model: Model) => {
    const resourceNodeData = model.nodeDataArray.find(
      (nodeData) => nodeData.key === getResourceKey(projectResourceId)
    );
    if (resourceNodeData && isResource(resourceNodeData)) {
      setDataProperty<Resource>(model)(
        resourceNodeData,
        'text',
        newResourceName
      );
    }
  };
